import { ITimeSlotsDetails } from "@/api/AppApi/services/time-slots/interfaces/api-time-slots-interfces";
import { DropdownButton, DropdownItem, Row } from "@/utils/bootstrap";
import SortDropdownTitle from "@/app/components/lib/sort-dropdown/SortDropdownTitle";

interface Props {
  services: ITimeSlotsDetails[];
  selectedServiceId: number | null;
  setSelectedServiceId: (id: number | null) => void;
}

const AppointmentTypesDropdown: React.FC<Props> = ({
  services,
  selectedServiceId,
  setSelectedServiceId,
}) => {
  if (services?.length === 1) return <div>{services[0].name}</div>;
  return (
    <div className="appointment-dropdown">
      <DropdownButton
        variant="outline"
        onSelect={(e) => e && setSelectedServiceId(+e)}
        title={
          <SortDropdownTitle
            title={
              services?.find((st) => st.id === selectedServiceId)?.name ?? ""
            }
          />
        }
      >
        {services?.map((service) => (
          <DropdownItem
            active={service?.id === selectedServiceId}
            key={service.id}
            eventKey={service?.id}
          >
            <Row className="m-0">{service?.name}</Row>
          </DropdownItem>
        ))}
      </DropdownButton>
    </div>
  );
};

export default AppointmentTypesDropdown;
